import { render } from "./MbolWarning.vue?vue&type=template&id=70183ffc&ts=true"
import script from "./MbolWarning.vue?vue&type=script&lang=ts"
export * from "./MbolWarning.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__